export default __webpack_public_path__ + "static/media/Thug's Wristbands of Waning Dusk.3b78fa35.jpg";